import { useState } from 'react';
import TagManager from 'react-gtm-module';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validation } from '../../validations';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import { QuizzData } from '../../types';
import { useParams } from "react-router-dom";
import { handleBavyroxQuizz } from '../../services';
import { bavyroxLinks } from '../../constants';
import { Footer, LineBroken } from '../home/style';
import { BavyroxLogo } from '../../assets';
import { useQuizNavigation } from '../../hooks';
import { formatLeadPhone } from '../../utils/phone';

const TOTAL_STEPS = 3;

export default function QuizBavyrox() {
  const { step, goNext, goBack, canGoBack } = useQuizNavigation(TOTAL_STEPS);
  const [option, setOption] = useState('');

  const { reset } = useForm({ resolver: yupResolver(validation) });
  const { slug } = useParams();

  const handleLinkSelection = (reponse: string) => {
    setOption(reponse);
    goNext();
  };

  const redirect = () => {
    const baseUrl = bavyroxLinks.redirect;
    const currentParams = window.location.search;
    const url = currentParams ? `${baseUrl}${currentParams}` : baseUrl;
    window.open(url, '_self');
  }

  const onSubmitHandler = async (data: QuizzData, isEmailValid?:boolean) => {
    try {
      const params = new URLSearchParams(window.location.search);
      const dataformated = {
        source: slug,
        phone: formatLeadPhone(data?.phone),
        email: data.email,
        fullName: data.name,
        utmSource: params.get('utm_source'),
        utmMedium: params.get('utm_medium'),
        utmCampaign: params.get('utm_campaign'),
        random: Math.floor(Math.random() * 10)
      } as any
      
      if(isEmailValid){
        try {
          await handleBavyroxQuizz(dataformated);
        } catch (e) {
          console.error('Erro ao enviar lead para Mautic:', e);
        }
        try {
          TagManager.dataLayer({
            dataLayer: {
              event: 'lead',
              data: dataformated,
            }
          });
          if (typeof window !== 'undefined' && (window as any).fbq) {
            (window as any).fbq('track', 'Lead');
          }
        } catch (error) {
          console.error('Erro ao enviar os dados para o TagManager!');
        }
      }
      redirect();
      reset();
    } catch (error:any) {
      redirect();
      console.error('Erro na solicitação!, tente novamente mais tarde!');
    }
  };

  const steps: Record<number, JSX.Element> = {
    1: <Step1 step={step} onClick={goNext} />,
    2: <Step2 step={step} onClick={(option) => handleLinkSelection(option)} onBack={canGoBack ? goBack : undefined} />,
    3: <Step3 step={step} option={option} onSubmit={onSubmitHandler} onBack={canGoBack ? goBack : undefined} />,
  };
  return (
    <>
      {steps[step]}

      <Footer>
        <LineBroken /> 
        <div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: 15}}>
          <img src={BavyroxLogo} alt='logo' style={{width: 80, height: 22, objectFit: 'contain' }} /> &nbsp; &nbsp; &nbsp;
          ©{new Date().getFullYear()} |  https://bavyrox.com Todos os direitos reservados
          </div>
      
          <div style={{marginBottom: 15}}>
          Job Holding LTDA<br/>
          contato@bavyrox.com
          </div>
          <div>
            <a href={bavyroxLinks.privacy} target='_blank' rel='noreferrer'> Políticas de privacidade </a> |
            <a href={bavyroxLinks.terms} target='_blank' rel='noreferrer'> Termos de Serviço </a> |
            <a href={bavyroxLinks.disclaimer} target='_blank' rel='noreferrer'> Disclaimer </a>
          </div>
       
        </div>
      </Footer>
    </>
  );
}
